/* @flow weak */
export default function(phone) {
  if (/[a-zA-Z]/.test(phone)) {
    return false;
  }

  const stripped = phone.replace(/[^0-9]/g, '');
  return stripped.length === 10 || (stripped.length === 11 && stripped.charAt(0) === '1');
}
